import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';
import Screen from '../../../../shared/utils/screen';

const AddonModalIcon = styled.img<React.CSSProperties>`
  height: ${150 * Screen.widthRatio}px;
  margin-bottom: ${75 * Screen.widthRatio}px;
`;

export default withImage(AddonModalIcon, true);
